import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";
import axios from "axios";

const initialState = {
    loading: false,
    data: null,
    error: null,
    ticketList: null,
    response: null,
    myTicket: null,
    addMember: null,
    employeeList: null,
    count: null,
    openedTicket: null,
    addCategory: null,

};

export const fetchTicketList = createAsyncThunk(
    "fetchTicketList",
    async (body) => {

        try {
            const response = await instance.get(
                `/remark/remarkticket/remark-ticket-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
export const getMyTicketList = createAsyncThunk(
    "getMyTicketList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/remarkticket/remark-my-ticket-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
export const addNewCategory = createAsyncThunk(
    "addNewCategory",
    async (data) => {
        try {
            const response = instance.post("remark/remarkticket/add-category", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
export const addAcceptSupportReq = createAsyncThunk(
    "addAcceptSupportReq",
    async (data) => {


        try {
            const response = instance.post(`remark/remarkticket/accept-support-req?ticket_id=${data}`);
            return response.data;

        } catch (error) {
            throw error;
        }
    }
);

export const addTicketMember = createAsyncThunk(
    "addTicketMember",
    async (body) => {

        const formData = new FormData();
        formData.append("ticket_id", body.ticket_id);
        formData.append("ticket_member", body.ticket_member);

        try {
            const response = await instance.post(
                `remark/remarkticket/invite-member`, formData
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const getCmoEmployeeList = createAsyncThunk(
    "getCmoEmployeeList",
    async () => {
        try {
            const response = await instance.get(
                `crm/employees/get-cmo-employee-list`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const updateTicketStatus = createAsyncThunk(
    "updateTicketStatus",
    async (body) => {
        try {
            const response = await instance.post(
                `remark/remarkticket/update-ticket-status?ticket_id=${body.ticket_id}`, body
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const TicketRemarkSlice = createSlice({
    name: "ticketRemarkSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTicketList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchTicketList.fulfilled, (state, action) => {
            state.loading = false;
            state.ticketList = action.payload;
            state.count = action?.payload?.count;

        });
        builder.addCase(fetchTicketList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(getMyTicketList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getMyTicketList.fulfilled, (state, action) => {
            state.loading = false;
            state.myTicket = action.payload;
            state.count = action?.payload?.count;
        });
        builder.addCase(getMyTicketList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        builder.addCase(addTicketMember.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addTicketMember.fulfilled, (state, action) => {
            state.loading = false;
            state.addMember = action.payload;
        });
        builder.addCase(addTicketMember.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(getCmoEmployeeList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getCmoEmployeeList.fulfilled, (state, action) => {
            state.loading = false;
            state.employeeList = action.payload;
        });
        builder.addCase(getCmoEmployeeList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        builder.addCase(addNewCategory.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addNewCategory.fulfilled, (state, action) => {
            state.loading = false;
            state.addCategory = action.payload?.addCategory;
        });
        builder.addCase(addNewCategory.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(addAcceptSupportReq.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addAcceptSupportReq.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload?.data;
        });
        builder.addCase(addAcceptSupportReq.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(updateTicketStatus.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(updateTicketStatus.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(updateTicketStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

export default TicketRemarkSlice.reducer;
